module.exports = __webpack_public_path__ + "static/media/fordfoundation.a1d924f5.svg";